import { useEffect } from "react";

const psiToBar = (psi, decimals = 2) => {
    const bar = parseFloat(psi) * 0.0689476;
    return parseFloat(bar.toFixed(decimals));
};

function DashboardActiveMainTyres({value, userData}) {
    useEffect(() => {
        if (userData["pressure-unit"] === "bar") {
            value["tyre-FL:pressure"] = psiToBar(value["tyre-FL:pressure"])
            value["tyre-FR:pressure"] = psiToBar(value["tyre-FR:pressure"])
            value["tyre-RL:pressure"] = psiToBar(value["tyre-RL:pressure"])
            value["tyre-RR:pressure"] = psiToBar(value["tyre-RR:pressure"])
        }
    }, [userData])

    const getTyreTempColor = (v) => {
        const colorClass = v < 50 ? "bg-acc-blue shadow-[rgba(0,183,255,0.3)]" 
                        : v < 90 ? "bg-acc-green shadow-[rgba(11,218,91,0.3)]" 
                        : v < 120 ? "bg-acc-yellow shadow-[rgba(255,255,0,0.3)]" 
                        : "bg-acc-red shadow-[rgba(255,0,0,0.3)]";

        return `w-12 h-20 ${colorClass} rounded-md shadow-[0_0_15px] flex flex-col items-center justify-center relative overflow-hidden transition-colors duration-300`;
    };

    const getTyreWearColor = (v) => {
        const colorClass = v < 50 ? "text-acc-green" 
                        : v < 80 ? "text-acc-yellow" 
                        : "text-acc-red" 

        return `${colorClass}`;
    };

    const getTyreWearBg = (v, type) => {
        const colorClass = v < 50 ? "bg-acc-green" 
                        : v < 80 ? "bg-acc-yellow" 
                        : "bg-acc-red" 

        if (type === 0) {
            return `h-full ${colorClass}`;
        } else {
            return `h-full ${colorClass} ml-auto`;
        }
    };

    const getBrakeTempColor = (v) => {
        const colorClass = v < 180 ? "bg-acc-blue" 
                        : v < 600 ? "bg-acc-green" 
                        : v < 850 ? "bg-acc-yellow"
                        : "bg-acc-red" 

        return `${colorClass} w-full rounded-sm transition-colors duration-300`;
    };

    return (
        <div className="flex flex-col gap-3 rounded-xl border border-[#324d67] bg-background-dark/40 p-4">
            <div className="flex items-center justify-between">
                <p className="text-[10px] font-bold uppercase text-[#92adc9] tracking-widest">Live Tire Management</p>
                <div className="flex gap-3">
                    <div className="flex items-center gap-1">
                        <div className="size-1.5 rounded-full bg-acc-blue"></div><span className="text-[9px] uppercase font-bold text-[#92adc9]">Cold</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <div className="size-1.5 rounded-full bg-acc-green"></div><span className="text-[9px] uppercase font-bold text-[#92adc9]">Opt</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <div className="size-1.5 rounded-full bg-acc-red"></div><span className="text-[9px] uppercase font-bold text-[#92adc9]">Hot</span>
                    </div>
                </div>
            </div>
            <div className="flex-1 grid grid-cols-2 grid-rows-2 gap-3 items-center justify-center max-w-2xl mx-auto w-full">
                <div className="flex items-center gap-3 bg-[#111a22]/50 p-2 rounded-lg border border-[#324d67]/30">
                    <div className="relative flex flex-row-reverse items-center gap-[2px]">
                        <div className="w-4 h-[50px] bg-[#111a22] rounded-sm overflow-hidden border border-white/10">
                            <div className={getBrakeTempColor(value["brake-FL:temp"])} style={{height: Math.trunc((100 - value["brake-FL:wear"]*3)*100) + "%"}}></div>
                        </div>

                        <div className={getTyreTempColor(Math.trunc(value["tyre-FL:temp"]))}>
                            <div className="absolute inset-0 bg-black/10"></div>
                            <span className="text-black font-black text-lg z-10 leading-none">{Math.trunc(value["tyre-FL:temp"])}°</span>
                            <span className="text-black/60 font-bold text-[8px] absolute bottom-1 uppercase">FL</span>
                        </div>
                    </div>
                    <div className="flex flex-col gap-1 flex-1">
                        <div>
                            <span className="text-[8px] uppercase font-bold text-[#92adc9]">Pressure</span>
                            <p className="text-base font-black text-white italic leading-none">{(Math.floor(value["tyre-FL:pressure"] * 10) / 10).toFixed(1)} <span className="text-[8px] not-italic text-[#92adc9] uppercase">{userData["pressure-unit"]}</span></p>
                        </div>
                        <div className="space-y-1">
                            <div className="flex justify-between items-center text-[8px] uppercase font-bold">
                                <span className="text-[#92adc9]">Wear</span>
                                <span className={getTyreWearColor(Math.trunc(value["tyre-FL:wear"]))}>{Math.trunc((value["tyre-FL:wear"])*100)}%</span>
                            </div>
                            <div className="h-1 w-full bg-[#111a22] rounded-full overflow-hidden">
                                <div className={getTyreWearBg(Math.trunc(value["tyre-FL:wear"]), 0)} style={{width: Math.trunc((value["tyre-FL:wear"])*100) + "%"}}></div>
                            </div>
                        </div>
                        <div>
                            <span className="text-[8px] uppercase font-bold text-[#92adc9]">Brake: {Math.trunc(value["brake-FL:temp"])}°C | Wear: {Math.trunc((100 - value["brake-FL:wear"]*3)%100)}%</span>
                        </div>
                    </div>
                </div>
                <div className="flex items-center flex-row-reverse gap-3 bg-[#111a22]/50 p-2 rounded-lg border border-[#324d67]/30">
                    <div className="relative flex flex-row-reverse items-center gap-[2px]">
                        <div className={getTyreTempColor(Math.trunc(value["tyre-FR:temp"]))}>
                            <div className="absolute inset-0 bg-black/10"></div>
                            <span className="text-black font-black text-lg z-10 leading-none">{Math.trunc(value["tyre-FR:temp"])}°</span>
                            <span className="text-black/60 font-bold text-[8px] absolute bottom-1 uppercase">FR</span>
                        </div>

                        <div className="w-4 h-[50px] bg-[#111a22] rounded-sm overflow-hidden border border-white/10">
                            <div className={getBrakeTempColor(value["brake-FR:temp"])} style={{height: Math.trunc((33 - value["brake-FR:wear"])*100) + "%"}}></div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-1 flex-1 text-right">
                        <div>
                            <span className="text-[8px] uppercase font-bold text-[#92adc9]">Pressure</span>
                            <p className="text-base font-black text-white italic leading-none">{(Math.floor(value["tyre-FR:pressure"] * 10) / 10).toFixed(1)} <span className="text-[8px] not-italic text-[#92adc9] uppercase">{userData["pressure-unit"]}</span></p>
                        </div>
                        <div className="space-y-1">
                            <div className="flex justify-between items-center text-[8px] uppercase font-bold">
                                <span className={getTyreWearColor(Math.trunc(value["tyre-FR:wear"]))}>{Math.trunc((value["tyre-FR:wear"])*100)}%</span>
                                <span className="text-[#92adc9]">Wear</span>
                            </div>
                            <div className="h-1 w-full bg-[#111a22] rounded-full overflow-hidden">
                                <div className={getTyreWearBg(Math.trunc(value["tyre-FR:wear"]), 1)} style={{width: Math.trunc((value["tyre-FR:wear"])*100) + "%"}}></div>
                            </div>
                        </div>

                        <div>
                            <span className="text-[8px] uppercase font-bold text-[#92adc9]">Brake: {Math.trunc(value["brake-FR:temp"])}°C | Wear: {Math.trunc((100 - value["brake-FR:wear"]*3)%100)}%</span>
                        </div>
                    </div>
                </div>
                <div className="flex items-center gap-3 bg-[#111a22]/50 p-2 rounded-lg border border-[#324d67]/30">
                    <div className="relative flex flex-row-reverse items-center gap-[2px]">
                        <div className="w-4 h-[50px] bg-[#111a22] rounded-sm overflow-hidden border border-white/10">
                            <div className={getBrakeTempColor(value["brake-RL:temp"])} style={{height: Math.trunc((33 - value["brake-RL:wear"])*100) + "%"}}></div>
                        </div>

                        <div className={getTyreTempColor(Math.trunc(value["tyre-RL:temp"]))}>
                            <div className="absolute inset-0 bg-black/10"></div>
                            <span className="text-black font-black text-lg z-10 leading-none">{Math.trunc(value["tyre-RL:temp"])}°</span>
                            <span className="text-black/60 font-bold text-[8px] absolute bottom-1 uppercase">RL</span>
                        </div>
                    </div>

                    <div className="flex flex-col gap-1 flex-1">
                        <div>
                            <span className="text-[8px] uppercase font-bold text-[#92adc9]">Pressure</span>
                            <p className="text-base font-black text-white italic leading-none">{(Math.floor(value["tyre-RL:pressure"] * 10) / 10).toFixed(1)} <span className="text-[8px] not-italic text-[#92adc9] uppercase">{userData["pressure-unit"]}</span></p>
                        </div>
                        <div className="space-y-1">
                            <div className="flex justify-between items-center text-[8px] uppercase font-bold">
                                <span className="text-[#92adc9]">Wear</span>
                                <span className={getTyreWearColor(Math.trunc(value["tyre-RL:wear"]))}>{Math.trunc((value["tyre-RL:wear"])*100)}%</span>
                            </div>
                            <div className="h-1 w-full bg-[#111a22] rounded-full overflow-hidden">
                                <div className={getTyreWearBg(Math.trunc(value["tyre-RL:wear"]), 0)} style={{width: Math.trunc((value["tyre-RL:wear"])*100) + "%"}}></div>
                            </div>
                        </div>

                        <div>
                            <span className="text-[8px] uppercase font-bold text-[#92adc9]">Brake: {Math.trunc(value["brake-RL:temp"])}°C | Wear: {Math.trunc((100 - value["brake-RL:wear"]*3)%100)}%</span>
                        </div>
                    </div>
                </div>
                <div className="flex items-center flex-row-reverse gap-3 bg-[#111a22]/50 p-2 rounded-lg border border-[#324d67]/30">
                    <div className="relative flex flex-row-reverse items-center gap-[2px]">
                        <div className={getTyreTempColor(Math.trunc(value["tyre-RR:temp"]))}>
                            <div className="absolute inset-0 bg-black/10"></div>
                            <span className="text-black font-black text-lg z-10 leading-none">{Math.trunc(value["tyre-RR:temp"])}°</span>
                            <span className="text-black/60 font-bold text-[8px] absolute bottom-1 uppercase">RR</span>
                        </div>

                        <div className="w-4 h-[50px] bg-[#111a22] rounded-sm overflow-hidden border border-white/10">
                            <div className={getBrakeTempColor(value["brake-RR:temp"])} style={{height: Math.trunc((33 - value["brake-RR:wear"])*100) + "%"}}></div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-1 flex-1 text-right">
                        <div>
                            <span className="text-[8px] uppercase font-bold text-[#92adc9]">Pressure</span>
                            <p className="text-base font-black text-white italic leading-none">{(Math.floor(value["tyre-RR:pressure"] * 10) / 10).toFixed(1)} <span className="text-[8px] not-italic text-[#92adc9] uppercase">{userData["pressure-unit"]}</span></p>
                        </div>
                        <div className="space-y-1">
                            <div className="flex justify-between items-center text-[8px] uppercase font-bold">
                                <span className={getTyreWearColor(Math.trunc(value["tyre-RR:wear"]))}>{Math.trunc((value["tyre-RR:wear"])*100)}%</span>
                                <span className="text-[#92adc9]">Wear</span>
                            </div>
                            <div className="h-1 w-full bg-[#111a22] rounded-full overflow-hidden">
                                <div className={getTyreWearBg(Math.trunc(value["tyre-RR:wear"]), 1)} style={{width: Math.trunc((value["tyre-RR:wear"])*100) + "%"}}></div>
                            </div>
                        </div>

                        <div>
                            <span className="text-[8px] uppercase font-bold text-[#92adc9]">Brake: {Math.trunc(value["brake-RR:temp"])}°C | Wear: {Math.trunc((100 - value["brake-RR:wear"]*3)%100)}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardActiveMainTyres;